import React from 'react'
import { Helmet as H } from 'react-helmet-async'

export const Helmet: React.FC<any> = H as any

interface IProps {
  value: string
}

export const Title = ({ value }: IProps) => {
  const name = process.env.REACT_APP_WEBSITE_NAME || 'Citrus'
  return (
    <Helmet>
      <title>{`${name} · ${value}`}</title>
    </Helmet>
  )
}
